const map = {
	"./hockey-jersey/background-hockey-jersey.png": 99,
	"./hockey-jersey/clipmask-hockey-jersey.svg": 6269,
	"./hockey-jersey/multiply-hockey-jersey.png": 3003,
	"./hockey-jersey/outline-hockey-jersey.svg": 3325,
	"./hockey-jersey/stripes/hockey-jersey-stripe-double-hem.svg": 8006,
	"./hockey-jersey/stripes/hockey-jersey-stripe-double-neck.svg": 9813,
	"./hockey-jersey/stripes/hockey-jersey-stripe-double-sleeve-body.svg": 7449,
	"./hockey-jersey/stripes/hockey-jersey-stripe-double-thin-sleeve-body.svg": 651,
	"./hockey-jersey/stripes/hockey-jersey-stripe-double-vertical-sleeve.svg": 1331,
	"./hockey-jersey/stripes/hockey-jersey-stripe-shoudler-double.svg": 8202,
	"./hockey-jersey/stripes/hockey-jersey-stripe-sleeve-ends.svg": 1131,
	"./hockey-jersey/stripes/hockey-jersey-stripe-triple-sleeve-body.svg": 8154,
	"./hockey-jersey/stripes/hockey-jersey-stripe-vertical-sleeve.svg": 8347,
	"./porthole-jersey/background-porthole-jersey.png": 4163,
	"./porthole-jersey/clipmask-porthole-jersey.svg": 1517,
	"./porthole-jersey/multiply-porthole-jersey.png": 5435,
	"./porthole-jersey/outline-porthole-jersey.svg": 1157,
	"./porthole-jersey/stripes/porthole-jersey-stripe-neck.svg": 2749,
	"./porthole-jersey/stripes/porthole-jersey-stripe-shoulders.svg": 9959,
	"./porthole-jersey/stripes/porthole-jersey-stripe-sleeves.svg": 7343,
	"./porthole-jersey/stripes/porthole-jersey-stripe-waist.svg": 6916,
	"./reversible/background-reversible.png": 6183,
	"./reversible/clipmask-reversible.svg": 6489,
	"./reversible/multiply-reversible.png": 491,
	"./reversible/outline-reversible.svg": 5499,
	"./reversible/stripes/reversible-jersey-stripe-neck-and-shoulders.svg": 6152,
	"./reversible/stripes/reversible-jersey-stripe-side.svg": 9956,
	"./reversible/stripes/reversible-jersey-stripe-two-stripe-collar.svg": 4273,
	"./reversible/stripes/reversible-jersey-stripe-two-stripe-waist.svg": 206,
	"./shooter-shirt/background-shooter-shirt.png": 6185,
	"./shooter-shirt/clipmask-shooter-shirt.svg": 8171,
	"./shooter-shirt/multiply-shooter-shirt.png": 8073,
	"./shooter-shirt/outline-shooter-shirt.svg": 8101,
	"./shooter-shirt/stripes/shooter-shirt-stripe-collar.svg": 3899,
	"./shooter-shirt/stripes/shooter-shirt-stripe-hem.svg": 6010,
	"./shooter-shirt/stripes/shooter-shirt-stripe-side-double.svg": 3421,
	"./shooter-shirt/stripes/shooter-shirt-stripe-side-thick.svg": 3993,
	"./shooter-shirt/stripes/shooter-shirt-stripe-side-thin.svg": 2219,
	"./shooter-shirt/stripes/shooter-shirt-stripe-sleeve-ends.svg": 5919,
	"./shooter-shirt/stripes/shooter-shirt-stripe-two-stripe-sleeves.svg": 4856,
	"./shorts/background-shorts.png": 2383,
	"./shorts/clipmask-shorts.svg": 8717,
	"./shorts/multiply-shorts.png": 6523,
	"./shorts/outline-shorts.svg": 9451,
	"./shorts/stripes/shorts-stripe-bottom-triangle.svg": 7028,
	"./shorts/stripes/shorts-stripe-one-leg.svg": 5209,
	"./shorts/stripes/shorts-stripe-side-panel-piping.svg": 7522,
	"./shorts/stripes/shorts-stripe-side-panel-thick.svg": 454,
	"./shorts/stripes/shorts-stripe-side-panel-thin.svg": 5402,
	"./shorts/stripes/shorts-stripe-top-triangle.svg": 640,
	"./shorts/stripes/shorts-stripe-two-stripe-bottom.svg": 3678,
	"./shorts/stripes/shorts-stripe-waistband.svg": 587
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6505;